import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import CustomSnackbar from '../components/shared/customSnackbar/CustomSnackbar'

const NotificationContainer = ({ messages }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
  }

  return (
    <CustomSnackbar
      open={open}
      title={t('notification.bonus-unlocked')}
      message={messages}
      onClose={handleClose}
    />
  )
}

export default NotificationContainer
